import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row no-wrap q-col-gutter-x-sm"
}

import {defineAsyncComponent, onBeforeUnmount, PropType} from 'vue';
import {FeedItem} from 'src/apps/recommender/types';
import RecommenderApi from 'src/apps/recommender/api'



export default /*@__PURE__*/_defineComponent({
  __name: 'FeedItemWrapper',
  props: {
  modelValue: {
    type: Object as PropType<any>,
    required: true,
  }
},
  setup(__props) {




const AdvertCard = defineAsyncComponent(() => import('src/apps/adverts/components/AdvertCard.vue'))
const StoryListItem = defineAsyncComponent(() => import('src/apps/stories/components/StoryListItem.vue'))
const ItemCard = defineAsyncComponent(() => import('src/apps/market/components/ItemCard.vue'))
const BlogListItem = defineAsyncComponent(() => import('src/components/blog/BlogListItem.vue'))

const FeedItemMapping = {
  'adverts': AdvertCard,
  'stories': StoryListItem,
  'market_items': ItemCard,
  'blogs': BlogListItem,
}


// const intersectionTimout = 800 // how long to wait before confirming visibility
// const visibleItems = ref<Set<string>>(new Set())
// const visibilityTimers = new Map<string, ReturnType<typeof setTimeout>>()
// function handleVisibilityConfirmed(itemId: string, itemType: FEED_ITEM_TYPES) {
//   RecommenderApi.postFeedInteractionImpression(
//     itemId,
//     itemType,
//   ).then(() => {
//     console.debug('Feed item impression sent', itemId, itemType)
//   }).catch((err) => {
//     console.error('Failed to send feed item impression', err)
//   })
// }
//
// // Function to clear visibility timer
// function clearVisibilityTimer(itemId: string) {
//   if (visibilityTimers.has(itemId)) {
//     clearTimeout(visibilityTimers.get(itemId))
//     visibilityTimers.delete(itemId)
//   }
// }
//
//
// const intersectionOptions = {
//   handler(entry: IntersectionObserverEntry) {
//     const itemId = entry.target.dataset.id
//     const itemType = entry.target.dataset.itemType
//     if (!itemId) return
//
//     if (entry.isIntersecting) {
//       // Start a timer when the item becomes visible
//       if (!visibilityTimers.has(itemId)) {
//         const timer = setTimeout(() => {
//           handleVisibilityConfirmed(itemId, itemType)
//           visibleItems.value.add(itemId) // Add to visible set
//         }, intersectionTimout) // 1 second delay
//
//         visibilityTimers.set(itemId, timer)
//       }
//     } else {
//       // If item is no longer visible, clear the timer
//       clearVisibilityTimer(itemId)
//     }
//   },
//   cfg: {
//     threshold: 1.0
//   }
// }

onBeforeUnmount(() => {
  // Clear all timers when the component is destroyed
  // visibilityTimers.forEach((timer) => clearTimeout(timer))
  // visibilityTimers.clear()
})


function onClickFeedItem(item) {
  RecommenderApi.postFeedInteractionClick(
    item?.data?._item_id,
    item?.item_type,
  ).then(() => {
    console.debug('Feed item impression sent', item?.data?._item_id, item?.item_type)
  }).catch((err) => {
    console.error('Failed to send feed item impression', err)
  })
}

function getCompAttrs(item: FeedItem) {
  switch (item.item_type) {
    case 'adverts':
      return {data: item.data}
    case 'stories':
      return {modelValue: item.data}
    case 'market_items':
      return {}
    case 'blogs':
      return {modelValue: item.data}
  }
}



return (_ctx: any,_cache: any) => {
  return ((__props.modelValue as any).item_type === 'market_items')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.modelValue as any).data, (obj) => {
          return (_openBlock(), _createElementBlock("div", {
            key: obj,
            class: "col-6"
          }, [
            _createVNode(_unref(ItemCard), {
              "model-value": obj,
              "data-id": obj._item_id,
              "data-item-type": __props.modelValue.item_type,
              onClick: ($event: any) => (onClickFeedItem({item_type: __props.modelValue.item_type, data: obj}))
            }, null, 8, ["model-value", "data-id", "data-item-type", "onClick"])
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(FeedItemMapping[(__props.modelValue as any).item_type]), _mergeProps({ key: 1 }, getCompAttrs((__props.modelValue as any)), {
        "data-id": __props.modelValue.data._item_id,
        "data-item-type": __props.modelValue.item_type,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickFeedItem(__props.modelValue)))
      }), null, 16, ["data-id", "data-item-type"]))
}
}

})